// extracted by mini-css-extract-plugin
module.exports = {"navigationItems":"NavigationItems_navigationItems__1LRCk"};